/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Last_30_DaysInputs */

const en_admin_dashboard_last_30_days = /** @type {(inputs: Admin_Dashboard_Last_30_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last 30 days`)
};

const de_admin_dashboard_last_30_days = /** @type {(inputs: Admin_Dashboard_Last_30_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte 30 Tage`)
};

const es_admin_dashboard_last_30_days = /** @type {(inputs: Admin_Dashboard_Last_30_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Últimos 30 días`)
};

const fr_admin_dashboard_last_30_days = /** @type {(inputs: Admin_Dashboard_Last_30_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 derniers jours`)
};

const nl_admin_dashboard_last_30_days = /** @type {(inputs: Admin_Dashboard_Last_30_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laatste 30 dagen`)
};

const it_admin_dashboard_last_30_days = /** @type {(inputs: Admin_Dashboard_Last_30_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultimi 30 giorni`)
};

const pt_br2_admin_dashboard_last_30_days = /** @type {(inputs: Admin_Dashboard_Last_30_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Últimos 30 dias`)
};

const pl_admin_dashboard_last_30_days = /** @type {(inputs: Admin_Dashboard_Last_30_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ostatnie 30 dni`)
};

const hu_admin_dashboard_last_30_days = /** @type {(inputs: Admin_Dashboard_Last_30_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utolsó 30 nap`)
};

const ro_admin_dashboard_last_30_days = /** @type {(inputs: Admin_Dashboard_Last_30_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultimele 30 de zile`)
};

/**
* | output |
* | --- |
* | "Last 30 days" |
*
* @param {Admin_Dashboard_Last_30_DaysInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_last_30_days = /** @type {((inputs?: Admin_Dashboard_Last_30_DaysInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Last_30_DaysInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_last_30_days(inputs)
	if (locale === "de") return de_admin_dashboard_last_30_days(inputs)
	if (locale === "es") return es_admin_dashboard_last_30_days(inputs)
	if (locale === "fr") return fr_admin_dashboard_last_30_days(inputs)
	if (locale === "nl") return nl_admin_dashboard_last_30_days(inputs)
	if (locale === "it") return it_admin_dashboard_last_30_days(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_last_30_days(inputs)
	if (locale === "pl") return pl_admin_dashboard_last_30_days(inputs)
	if (locale === "hu") return hu_admin_dashboard_last_30_days(inputs)
	return ro_admin_dashboard_last_30_days(inputs)
});
export { admin_dashboard_last_30_days as "admin.dashboard.last_30_days" }